import { mongoDBRequest } from "./dbRequest";

export const portfolioService = {
  // Accounts
  createAccount: async (accountData) => {
    return await mongoDBRequest("portfolio/account/create", "POST", accountData);
  },

  getAllAccounts: async () => {
    return await mongoDBRequest("portfolio/account/all", "GET");
  },

  updateAccount: async (accountData) => {
    return await mongoDBRequest("portfolio/account/update", "POST", accountData);
  },

  deleteAccount: async (accountId) => {
    return await mongoDBRequest("portfolio/account/delete", "DELETE", {
      _id: accountId,
    });
  },

  // Expenses
  createExpense: async (expenseData) => {
    return await mongoDBRequest("portfolio/expense/create", "POST", expenseData);
  },

  getAllExpenses: async () => {
    return await mongoDBRequest("portfolio/expense/all", "GET");
  },

  updateExpense: async (expenseData) => {
    return await mongoDBRequest("portfolio/expense/update", "POST", expenseData);
  },

  deleteExpense: async (expenseId) => {
    return await mongoDBRequest("portfolio/expense/delete", "DELETE", {
      _id: expenseId,
    });
  },

  // Outside Income
  createOutsideIncome: async (incomeData) => {
    return await mongoDBRequest("portfolio/outside-income/create", "POST", incomeData);
  },

  getAllOutsideIncome: async () => {
    return await mongoDBRequest("portfolio/outside-income/all", "GET");
  },

  updateOutsideIncome: async (incomeData) => {
    return await mongoDBRequest("portfolio/outside-income/update", "POST", incomeData);
  },

  deleteOutsideIncome: async (incomeId) => {
    return await mongoDBRequest("portfolio/outside-income/delete", "DELETE", {
      _id: incomeId,
    });
  },

  // Stats
  getStats: async (groupId = "default") => {
    return await mongoDBRequest(`portfolio/stats?groupId=${groupId}`, "GET");
  },

  // Real Account Balances
  getRealBalances: async () => {
    return await mongoDBRequest("portfolio/real-balances", "GET");
  },
};
